<button *ngIf="(isCollectionAdmin$ | async)" class="dropdown-item"
        [routerLink]="getBulkImportPageRouterLink()" [innerHTML]="'context-menu.actions.bulk-import.btn' | translate">
</button>
